import { Workbook } from 'exceljs'
import { downFile } from './file'

export async function exportXlsxFile(filename, columns, columnFormatter, data) {
  var workbook = new Workbook()
  var sheet1 = workbook.addWorksheet('sheet1')
  sheet1.columns = columns
  var keys = Object.keys(columnFormatter)
  if (keys.length > 0) {
    for (var item of data) {
      var newItem = Object.assign({}, item)
      for (var key of keys) {
        newItem[key] = columnFormatter[key]({ row: newItem }, newItem[key])
      }
      sheet1.addRow(newItem)
    }
  } else {
    sheet1.addRows(data)
  }
  var headerRow = sheet1.getRow(1)
  if (headerRow) {
    //表头加粗
    headerRow.eachCell((cell) => {
      cell.font = { bold: true }
    })
  }
  var buffer = await workbook.xlsx.writeBuffer()
  downFile(filename, buffer)
}

/**
 * 读取xlsx文件
 * @param {File} file 文件
 * @param {Function} rawData2JsonFunc 原始数据转换为自定义对象json函数
 * @returns {Promise<Array<any>>} 返回json数据
 */
export async function readXlsxFile(file, rawData2JsonFunc) {
  var workbook = new Workbook()
  var buffer = await file.arrayBuffer()
  await workbook.xlsx.load(buffer)
  var sheet1 = workbook.getWorksheet(1)
  // console.log('sheet1', sheet1, sheet1.columns)
  var rawData = []
  sheet1.eachRow((row) => {
    var newRow = []
    row.eachCell({ includeEmpty: true }, (cell) => {
      newRow.push(cell.value)
    })
    rawData.push(newRow)
  })
  if (typeof rawData2JsonFunc === 'function') {
    return rawData2JsonFunc(rawData)
  }
  return rawData
}

/**
 * 读取xlsx文件为json
 * @param {File} file 文件
 * @param {Object} options 选项
 * @returns {Promise<Array>} 返回json数据
 */
export function readXlsxFileToJson(file, options) {
  var opts = {
    columnWRowIndex: 0, //列头行索引
    dataRowIndex: 1, //数据行索引
    keyMap: {}, //键值映射
    ...(options || {})
  }
  var keyMap = opts.keyMap || {}
  return readXlsxFile(file, (rawData) => {
    if (rawData.length > opts.columnWRowIndex) {
      var columnRow = rawData[opts.columnWRowIndex]
      var data = []
      for (var i = opts.dataRowIndex; i < rawData.length; i++) {
        var newItem = {}
        for (
          var columnIndex = 0;
          columnIndex < columnRow.length;
          columnIndex++
        ) {
          var key = columnRow[columnIndex]
          if (keyMap[key]) {
            key = keyMap[key]
          }
          newItem[key] = rawData[i][columnIndex]
        }
        data.push(newItem)
      }
      return data
    }
    return []
  })
}
